import styles from './styles.module.scss';

import { Header } from '../header/index';
import { MenuSide } from '../menu/index';
import { Footer } from '../footer/Footer';
import MovimentacaoBancario from '../Financeiro/MovimentacaoBancaria/MovimentacaoBancaria';
import ExtratoBancario from '../Financeiro/ExtratoBancario/ExtratoBancario';

export interface LayoutProps {
  children: React.ReactNode;
}

export function GlobalLayout(props: LayoutProps) {
  return (
    <>
      <div className={styles.container}>
        <MenuSide />
        <Header />
        <main className={styles.children}>{props.children}</main>
        <Footer />
      </div>
      <MovimentacaoBancario />
      <ExtratoBancario />
    </>
  );
}

export default GlobalLayout;
